import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { AssessmentQuestionBase } from "../models/assessment-question-base.model";
import { NG_VALUE_ACCESSOR } from "@angular/forms";


@Component({
    selector: 'single-choice-question',
    templateUrl: './single-choice-question.component.html',
    styleUrls: ['./single-choice-question.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SingleChoiceQuestionComponent),
            multi: true
        }
    ],
    standalone: false
})
  export class SingleChoiceQuestionComponent {
    @Input() question: any;
    // @Input() question: any;
    @Input('value') _value: any;
    @Output() valueChange = new EventEmitter<any>();
    propagateChange = (_: any) => { };
    onTouched: any = () => { };
    selectedValue: any;
    constructor(){

    }
    ngOnInit() {
        console.log("Single Choice Question",this.question);
    }
    
    get value(): any {
      return this._value;
    }
  
    set value(val) {
      this._value = val;
      this.propagateChange(val);
      this.onTouched();
    }
    isSelected(option, question) {
      // Determine if the current radio option is selected based on the selectedValue
      const value = this.getRadioValue(option, question);
      return value === this.selectedValue;
    }

    getRadioValue(option, question) {
      // Use the getterKey logic, or fall back to option.id or option.value
      return question.getterKey ? this.getKey(option, question) : option.id || option.value;
    }

    getRadioId(option, question) {
      // Similarly, set the radio button's id using the getterKey or fallback value
      return question.getterKey ? this.getKey(option, question) : option.id || option.value;
    }
  
    writeValue(value) {
      if (value) {
        this.value = value;
        this.selectedValue = this.value;
        this.setvalueForUpdate(this.value);
      } else {
        this.value = "";
        this.selectedValue = "";
      }
      this.propagateChange(value);
    }
  
    setvalueForUpdate(value) {
    }
    registerOnChange(fn: any) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
    getKey(option, key) {
      if (option.hasOwnProperty(key.getterKey)) {
        if (key.flag) {
          return option;
        }
        else {
          return option[key.getterKey];
        }
  
      }
    }
    getValue(option, value) {
      if (option.hasOwnProperty(value)) {
        return option[value];
      }
    }
  }